import React, { forwardRef } from "react";

interface InputProps {
  label: string;
  value: string;
  disabled: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  borderClassName?: string;
  valueClassName?: string;
  tagClassName?: string;
  name?: string;
}

export const HeaderInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { label, value, disabled, onChange, placeholder, borderClassName, valueClassName, tagClassName, name } = props;
  const outerClasses = "flex space-x-2 w-full items-center";
  const inputClasses = "w-full grow text-xl placeholder:text-gray-300 focus-visible:outline-0";
  const labelClasses = "flex uppercase align-middle leading-10 text-neutral-700";
  const inputClassName = valueClassName ? `${valueClassName} ${inputClasses}` : inputClasses;
  const outerClassName = borderClassName ? `${borderClassName} ${outerClasses}` : `${outerClasses} border-gray-300`;
  const labelClassName = tagClassName ? `${tagClassName} ${labelClasses}` : labelClasses;

  return (
    <div className={outerClassName}>
      <label htmlFor={label} className={labelClassName}>
        {label}
      </label>
      <input
        ref={ref}
        className={inputClassName}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        id={label}
        name={name}
        onChange={onChange}
      />
    </div>
  );
});
